import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../../api/errors/api-error-codes';

export const addManualWorkingHoursOperation = async (
  userId: number,
  branchId: number | null,
  activityTypeId: number | null,
  rateId: number | null,
  date: Date | null,
  startTime: Date | null,
  endTime: Date | null,
  notes?: string | null,
  workingHoursId?: number | null, // Optional ID for edit mode
  breakMinutes?: number | null,
): Promise<boolean> => {
  try {
    if (
      !date ||
      !startTime ||
      !endTime ||
      !activityTypeId ||
      !branchId ||
      !rateId
    ) {
      toast.warn('יש למלא את כל השדות');
      return false;
    }

    // Combine date's year/month/day with startTime's hours/minutes
    const combinedStartTime = new Date(date);
    combinedStartTime.setHours(
      startTime.getHours(),
      startTime.getMinutes(),
      0,
      0,
    );

    // Combine date's year/month/day with endTime's hours/minutes
    const combinedEndTime = new Date(date);
    combinedEndTime.setHours(endTime.getHours(), endTime.getMinutes(), 0, 0);

    // For now, use the same API call for both add and edit modes
    // The backend can be updated later to handle edit mode with the workingHoursId
    if (workingHoursId) {
      const normalizedBreakMinutes =
        breakMinutes === null || breakMinutes === undefined
          ? null
          : breakMinutes;
      if (
        normalizedBreakMinutes !== null &&
        (!Number.isInteger(normalizedBreakMinutes) ||
          normalizedBreakMinutes < 0 ||
          normalizedBreakMinutes > 60)
      ) {
        toast.warn('דקות הפסקה חייבות להיות מספר שלם בין 0 ל-60');
        return false;
      }

      const res = await appApi.updateManualWorkingHours(
        workingHoursId,
        userId,
        branchId,
        activityTypeId,
        rateId,
        combinedStartTime,
        combinedEndTime,
        notes ?? '',
        normalizedBreakMinutes,
      );
      if (res.data.errCode) {
        toast.warn(displayErrorText(res.data.errCode));
      }
    } else {
      await appApi.addManualWorkingHours(
        userId,
        branchId,
        activityTypeId,
        rateId,
        combinedStartTime,
        combinedEndTime,
        notes ?? '',
      );
    }
    return true;
  } catch (e) {
    toast.warn('לא ניתן לערוך כעת, נסה לרענן את העמוד...');
    console.error(
      `addManualWorkingHoursOperation is failed with the userId: ${userId}, branchId: ${branchId}, activityTypeId: ${activityTypeId}, rateId: ${rateId}, date: ${date}, startTime: ${startTime}, endTime: ${endTime}, notes: ${notes}, workingHoursId: ${workingHoursId}, breakMinutes: ${breakMinutes} with the error: ${e}`,
    );
    return false;
  }
};
